export const onGlobalFilterChange = (e, filters, setFilters, setGlobalFilterValue) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };